export default function formatInputNumberWithTwoDecimals(
  inputNumber: number | undefined | null
): string {
  return parseFloat(String(inputNumber || 0)).toFixed(2);
}
